import * as React from 'react';
import { ResponsiveStyleValue, SpacingValue } from '../../theming';
import { DEFAULT_GRID_COLUMNS } from '../../theming/types/components/FlexGrid.types';

export interface FlexGridContextValues {
    columnSpacing: ResponsiveStyleValue<SpacingValue>;
    rowSpacing: ResponsiveStyleValue<SpacingValue>;
    columns: number;
    disableEqualOverflow: boolean;
}

export const FlexGridContext = React.createContext<FlexGridContextValues>({
    columnSpacing: 0,
    rowSpacing: 0,
    columns: DEFAULT_GRID_COLUMNS,
    disableEqualOverflow: false,
});

export function useFlexGrid(): FlexGridContextValues {
    return React.useContext(FlexGridContext);
}
